import React, { useState } from 'react'
import Draggable, {
  ControlPosition,
  DraggableData,
  DraggableEvent
} from 'react-draggable'

import { DragHandleDots2Icon } from '@radix-ui/react-icons'
import { tx } from '@twind/core'

export type DraggableVideoProps = {
  position: ControlPosition
  children?: React.ReactNode
  handleOnDrag?({
    _e,
    _data
  }: {
    _e: DraggableEvent
    _data: DraggableData
  }): void
}

const DraggableVideo = (props: DraggableVideoProps) => {
  const { position, children, handleOnDrag } = props
  const [isDragging, setIsDragging] = useState(false)

  const handleOnDragStart = () => {
    setIsDragging(true)
  }
  const onStop = () => {
    setIsDragging(false)
  }

  return (
    <div className="fixed inset-0 h-[100vh] w-full pointer-events-none z-50">
      <Draggable
        onDrag={(e, data) => {
          handleOnDrag && handleOnDrag({ _e: e, _data: data })
        }}
        bounds="parent"
        onStart={handleOnDragStart}
        onStop={onStop}
        position={position}>
        <div className="flex-col absolute top-16 left-8 h-[200px] w-[300px] rounded-md bg-zinc-700 p-1 pt-1">
          <div className="flex items-center justify-center absolute top-0 -left-7 bg-zinc-700 rounded-l-md">
            <DragHandleDots2Icon className="h-7 w-8 p-1 cursor-grab active:cursor-grabbing pointer-events-auto" />
          </div>
          <div
            className={tx(
              'h-full w-full rounded-md overflow-hidden',
              isDragging ? 'pointer-events-none' : 'pointer-events-auto'
            )}>
            {children}
          </div>
        </div>
      </Draggable>
    </div>
  )
}

export default DraggableVideo
